import * as React from "react";
import type { SVGProps } from "react";
const Ranch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_1341)">
      <path
        fill="currentColor"
        d="M3.4874 11.1366v6.9748c0 .643.5195 1.1625 1.1625 1.1625h1.1625c.643 0 1.1624-.5195 1.1624-1.1625v-3.204a5.37 5.37 0 0 0 1.1625.5848v.8792c0 .3196.2616.5812.5813.5812.3196 0 .5812-.2616.5812-.5812v-.614c.1925.0218.385.0327.5812.0327s.3887-.0109.5813-.0327v.614c0 .3196.2615.5812.5812.5812s.5813-.2616.5813-.5812v-.8792a5.05 5.05 0 0 0 1.1624-.5848v3.204c0 .643.5195 1.1625 1.1625 1.1625h1.1625c.643 0 1.1625-.5195 1.1625-1.1625v-5.8123l1.1624 1.1624v1.7983c0 .3451.1018.6793.2943.9663l1.5221 2.285a1.72 1.72 0 0 0 1.4277.7628 1.7154 1.7154 0 0 0 1.6819-1.3804l.7375-3.6909a1.745 1.745 0 0 0-.2906-1.355l-.1417-.1998V9.6835a.87.87 0 0 0-.8719-.8719.8697.8697 0 0 0-.8718.8719v.5231l-1.9218-2.6918c-.9844-1.3732-2.5683-2.1906-4.2575-2.1906H5.2311C2.8226 5.3242.872 7.275.872 9.6835v1.9617C.3415 12.0738 0 12.7277 0 13.4615v.6394a.521.521 0 0 0 .5231.5231c1.1552 0 2.0925-.9372 2.0925-2.0924V9.6835c0-.8827.4395-1.6638 1.108-2.1397a3.5 3.5 0 0 0-.2362 1.2679zm16.8559 4.0687a.5812.5812 0 1 1 1.1625.0001.5812.5812 0 0 1-1.1625-.0001M6.0521 9.0514a.825.825 0 0 1-.2397-.5812c0-.4541.3669-.821.821-.821h6.4917c.4541 0 .821.3669.821.821a.825.825 0 0 1-.2398.5812l-.85.85a4.198 4.198 0 0 1-2.9753 1.2352 4.21 4.21 0 0 1-2.9752-1.2315l-.85-.85z"
      />
    </g>
    <defs>
      <clipPath id="clip0_4362_1341">
        <path fill="transparent" d="M0 3h23.2495v18.5996H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default Ranch;
